




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InformationRow extends Vue {
	@Prop({ required: true, type: String })
	public title!: string;

	@Prop({ required: false})
	public value?: string | number | null;

	@Prop({ required: false, type: String })
	public tooltip?: string | null;

	@Prop({ required: false, type: Boolean, default: false })
	public warn!: boolean;

	@Prop({ required: false, type: Boolean, default: false })
	public date!: boolean;
}
